import {Component, HostListener, OnInit} from '@angular/core';
import {LoggedUser} from "../../common/logged-user.service";
import {AuthGuard} from "../../common/auth-guard.service";
import {DevicesService} from "../../services/devices.service";
import {Device} from "../../model/device";
import {DeviceFilters} from "../../model/filters/device-filters";
import * as moment from "moment/moment";
import {TimezoneService} from "../../services/timezone.service";
import {FiltersService} from "../../services/filters.service";
import {Organization} from "../../model/organization";
import {Tenant} from "../../model/tenant";
import {DeviceRemovedFilters} from "../../model/filters/device-removed-filters";
import {SortOrder} from "../../model/sort-order";
import {OrganizationsService} from "../../services/organizations.service";
import {TenantsService} from "../../services/tenants.service";
import {DeviceRemoved} from "../../model/device-removed";

@Component({
  selector: 'app-devices-removed',
  templateUrl: './devices-removed.component.html',
  styleUrls: ['./devices-removed.component.scss']
})
export class DevicesRemovedComponent implements OnInit {

  public devices: DeviceRemoved[];
  public totalDevices: number;
  public loadingDevices: boolean;

  public rows = 10;
  public first = 0;
  public selected = [];

  public filtersVisible: boolean;
  public currentFilters: DeviceRemovedFilters;
  public dateRanges: Date[];
  public tenants: Tenant[];
  public organizations: Organization[];
  public showDialog: boolean = false;
  public filtersFilled: boolean;

  constructor(public loggedUser: LoggedUser,
              public authGuardService: AuthGuard,
              private devicesService: DevicesService,
              private timezoneService: TimezoneService,
              private filtersService: FiltersService<DeviceRemovedFilters>,
              private organizationsService: OrganizationsService,
              private tenantsService: TenantsService) {
    this.currentFilters = new DeviceRemovedFilters();
  }

  ngOnInit(): void {
    if (this.filtersService.getCurrentFilters(this.constructor.name) !== undefined) {
      this.filtersFilled = true;
    }
    this.loadFilters().then(() => {
      Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
      if (this.currentFilters?.hasOwnProperty('rangeDates')) {
        this.dateRanges = [new Date(this.currentFilters.rangeDates[0]), new Date(this.currentFilters.rangeDates[1])];
      }
    });
    this.devices = new Array(this.rows);
  }

  private loadDevices(offset: number, limit: number): void {
    this.loadingDevices = true;
    this.devices = new Array(this.rows);
    this.trimFieldsForm(this.currentFilters);
    this.formatterDateForm(this.dateRanges);
    this.devicesService.getDevicesRemoved(offset, limit, this.filtersService.getCurrentFilters(this.constructor.name) === undefined ? this.currentFilters : this.filtersService.getCurrentFilters(this.constructor.name))
      .subscribe(response => {
        this.devices = response.devices;
        this.totalDevices = response.totalElements;
        this.loadingDevices = false;
      });
  }

  private loadFilters(): Promise<any> {
    let promises: Array<Promise<any>> = [this.organizationsService.getOrganizations().toPromise()];
    if (this.authGuardService.superAdminRequired()) {
      promises.push(this.tenantsService.getTenants().toPromise());
    }
    return Promise.all(promises).then(response => {
      this.organizations = response[0].organizations.sort((a, b) => a.name > b.name ? 1 : -1);
      if (this.authGuardService.superAdminRequired()) {
        this.tenants = response[1].tenants.sort((a, b) => a.name > b.name ? 1 : -1);
      }
    });
  }

  trimFieldsForm(filters: DeviceRemovedFilters): void {
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== undefined && typeof filters[key] === 'string') {
        filters[key] = filters[key].trim();
      }
    });
  }

  formatterDateForm(rangeDates: Date[]): void {
    if (rangeDates && rangeDates.length > 1) {
      if (!rangeDates[1]) {
        rangeDates[1] = moment.utc().toDate();
      }
      const utcRange = this.timezoneService.timestampRangeFromCalendarData(rangeDates);
      this.currentFilters.rangeDates = [utcRange.from, utcRange.until];
    }
  }

  onPageChange(event): void {
    this.currentFilters.sortField = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.loadDevices(event.first / event.rows, event.rows);
  }

  resetFilters(): void {
    this.currentFilters = new DeviceRemovedFilters();
    this.currentFilters.sortField = 'serialNumber';
    this.currentFilters.sortOrder = 0;
    this.dateRanges = null;
    this.filtersFilled = false;
    this.filtersService.setCurrentFilters(undefined, this.constructor.name);
    this.applyFilters(true);
  }

  applyFilters(reset?: boolean): void {
    this.first = 0;
    if (reset !== true) {
      this.filtersService.setCurrentFilters(this.currentFilters, this.constructor.name);
      this.filtersFilled = true;
    }
    this.loadDevices(this.first / this.rows, this.rows);
  }


  get filteredOrganizations(): Organization[] {
    if (this.authGuardService.superAdminRequired()) {
      if (this.currentFilters.tenantUuids?.length > 0) {
        return this.organizations?.filter(org => this.currentFilters.tenantUuids.includes(org.tenant.uuid));
      }
    }
    return this.organizations;
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.key === 'f' && !this.showDialog) {
      this.filtersVisible = true;
    }
    if (event.key === 'Escape') {
      this.filtersVisible = false;
    }
  }

  confirmAndDelete(device: Device): void {
      //TODO delete device permanent and measures
  }

  restoreDevice(device: Device): void {
      //TODO restore device
  }

}
